import { getURLQueryValueByKey } from "../../../utils/common.utils";

/**
 * Format URL with query parameters, return the URL including query parameters and token
 * @param {string} baseUrl - Base URL.
 * @param {{ [x: string]: number | string }=} params - URL query.
 * @return {string} The formatted URL.
 */
const formatURL = (
	baseUrl: string,
	params?: { [x: string]: number | string }
) => {
	const token = getURLQueryValueByKey("token") as string;
	const s2uType = getURLQueryValueByKey("s2uType") as string;
	const enableRetailFXFO = getURLQueryValueByKey("enableRetailFXFO") as string;
	const enableRetailFXRateAlert = getURLQueryValueByKey("enableRetailFXRateAlert") as string;
	const gaaActive = getURLQueryValueByKey("gaaActive") as string;
	const isS2UV5 = getURLQueryValueByKey("isS2UV5") as string;

	let query: string[] = [];
	if (params)
		query = Object.keys(params).map((k) => {
			return `${k}=${params[k].toString()}`;
		});

	return `${baseUrl}?s2uType=${s2uType}&enableRetailFXFO=${enableRetailFXFO}&enableRetailFXRateAlert=${enableRetailFXRateAlert}&gaaActive=${gaaActive}&isS2UV5=${isS2UV5}&token=${token}${
		query.length > 0 ? `&${query.join("&")}` : ""
	}`;
};

export default formatURL;
